export const SETS_SEARCH_TYPES = [
    {
        labelKey: 'receiveSets.setsInventory.searchType.setOrDescription',
        mobileLabelKey:
            'receiveSets.setsInventory.searchType.setOrDescriptionMobile',
        placeholderKey:
            'receiveSets.setsInventory.searchTypePlaceholder.setOrDescription',
        mobilePlaceholderKey:
            'receiveSets.setsInventory.searchTypePlaceholder.setOrDescriptionMobile',
        value: 'setOrDescription',
    },
    {
        labelKey: 'receiveSets.setsInventory.searchType.sapOrderMyCaseId',
        placeholderKey:
            'receiveSets.setsInventory.searchTypePlaceholder.ordernum',
        value: 'ordernum',
    },
];

export const SETS_TABLE_COLUMNS = [
    {
        field: 'setNumber',
        headerKey: 'receiveSets.setsInventory.tableHeaders.set',
        sortable: true,
        width: '28%',
    },
    {
        field: 'referenceNumbers',
        headerKey: 'receiveSets.setsInventory.tableHeaders.referenceNumbers',
        sortable: true,
        width: '20%',
    },
    {
        field: 'status',
        headerKey: 'receiveSets.setsInventory.tableHeaders.status',
        sortable: true,
        width: '18%',
    },
    {
        field: 'location',
        headerKey: 'receiveSets.setsInventory.tableHeaders.location',
        sortable: true,
        width: '24%',
    },
    { field: 'action', header: '', width: '8%' },
];
export const SETS_PAGE_LIMIT = 50;

// Table column field -> sortCode sent to /inventory/sets.
export const SETS_TABLE_SORT_CODE_MAP = {
    setNumber: 'setNumber',
    referenceNumbers: 'referenceNumber',
    status: 'status',
    location: 'homeAccName',
};

export const SETS_DEFAULT_TABLE_SORT_FIELD = 'setNumber';
export const SETS_DEFAULT_TABLE_SORT_ORDER = 'ASC';

export const SETS_SORT_OPTIONS = [
    {
        code: 'setNumber-asc',
        labelKey: 'receiveSets.setsInventory.sortOptions.setAscending',
        field: 'setNumber',
        ascending: true,
    },
    {
        code: 'setNumber-desc',
        labelKey: 'receiveSets.setsInventory.sortOptions.setDescending',
        field: 'setNumber',
        ascending: false,
    },
    {
        code: 'referenceNumber-asc',
        labelKey: 'receiveSets.setsInventory.sortOptions.referenceNumberAscending',
        field: 'nextSurgerysstRefNo',
        ascending: true,
    },
    {
        code: 'referenceNumber-desc',
        labelKey: 'receiveSets.setsInventory.sortOptions.referenceNumberDescending',
        field: 'nextSurgerysstRefNo',
        ascending: false,
    },
    {
        code: 'status-asc',
        labelKey: 'receiveSets.setsInventory.sortOptions.statusAscending',
        field: 'status',
        ascending: true,
    },
    {
        code: 'status-desc',
        labelKey: 'receiveSets.setsInventory.sortOptions.statusDescending',
        field: 'status',
        ascending: false,
    },
    {
        code: 'location-asc',
        labelKey: 'receiveSets.setsInventory.sortOptions.locationAscending',
        field: 'homeAccName',
        ascending: true,
    },
    {
        code: 'location-desc',
        labelKey: 'receiveSets.setsInventory.sortOptions.locationDescending',
        field: 'homeAccName',
        ascending: false,
    },
];

export const SETS_DEFAULT_SORT_CODE = 'setNumber-asc';
